<script>
	import {send_data, user} from "../client.svelte.js";
		import { initials } from "../core.js";
		import Dialog from "../elements/Dialog.svelte";
		import { narrate, is_admin, fellow_name, fellow_heroes, upload_fshpImage } from "./_Narrate.svelte";

		let fshp = view.fellowship
		let admin = $derived(is_admin(fshp))
		let members = $derived(sort_byName(fshp?.members ?? []))
		//ToDo: fellows: {playerName, playerID, heroName, heroID, heroVocation, heroOrigin}

		/// member dialog: changes are collected and only sent when confirmed
		let pending = $state([])
		let query = $state("")
		let candidates = $derived(sort_byName(narrate.fellows.map(fellow => fellow.ID))
				.filter(userID => matches(userID, query.trim().toLowerCase())))

		function sort_byName(userIDs) {
				return [...userIDs].sort((a, b) => fellow_name(a).localeCompare(fellow_name(b)))
		}

		function matches(userID, text) {
				return !text || fellow_name(userID).toLowerCase().includes(text) || fellow_heroes(userID, fshp).toLowerCase().includes(text)
		}

		function change(e) {
				const {id, value} = e.target
				if (value !== (fshp[id] ?? ""))
					send_data(`/fellowship/${fshp.ID}`, {[id]: value}, 'PATCH')
		}

		function remove_member(userID) {
				if (confirm(`Soll ${fellow_name(userID)} wirklich aus der Gruppe „${fshp.name}“ entfernt werden?`))
					send_data(`/fellowship/${fshp.ID}`, {members: fshp.members.filter(member => member !== userID)})
		}

		function open_members() {
				pending = [...fshp.members]
				query = ""
		}

		function toggle_pending(userID) {
				pending = pending.includes(userID) ? pending.filter(member => member !== userID) : [...pending, userID]
		}

		function apply_members() {
				const changed = pending.length !== fshp.members.length || pending.some(member => !fshp.members.includes(member))
				if (changed)
					send_data(`/fellowship/${fshp.ID}`, {members: pending})
		}

		function upload_image(e) {
				const file = e.target.files[0]
				e.target.value = ""		// allows re-selecting the same file
				if (file)
					upload_fshpImage(fshp, file)
		}
</script>


<!-------------------------------- HTML -------------------------------------->

<article class="fellowship">
	{#if fshp}
		<header class="titleRow">
			<h1>Gruppe {fshp.ID}:</h1>
			<div class="field nameField">
				<input id="name" value={fshp.name} disabled={!admin} onchange={change} onkeydown={(e) => e.key === 'Enter' && e.target.blur()}>
			</div>
		</header>

		<div class="columns">
			<div class="column">
				<section class="card">
					<h3 class="card-title">Allgemeine Daten</h3>
					<div class="field">
						<label for="whereabout">Aufenthaltsort</label>
						<input id="whereabout" value={fshp.whereabout ?? ""} disabled={!admin} onchange={change}>
					</div>
					<div class="field">
						<label for="description">Beschreibung</label>
						<textarea id="description" rows="6" value={fshp.description ?? ""} disabled={!admin} onchange={change}></textarea>
					</div>
				</section>

				<fieldset class="card" data-help="members">
					<div class="cardTitleRow">
						<h3 class="card-title">Mitglieder <span class="card-meta">{members.length}</span></h3>
						{#if admin}
							<button class="btn-primary btn-primary-circle icon-user-plus" command="show-modal" commandfor="members-dialog" data-help="membersdialog"
							        onclick={open_members}>Mitglieder verwalten</button>
						{/if}
					</div>
					<ul class="memberList">
						{#each members as userID (userID)}
							{@render memberRow(userID)}
						{/each}
					</ul>
				</fieldset>
			</div>

			<section class="card imageCard" data-help="image">
				<h3 class="card-title">Gruppenbild</h3>
				{#if fshp.imageURL}
					<img class="fshpImage" src="/{fshp.imageURL}" alt="Gruppenbild {fshp.name}">
				{:else}
					<div class="fshpImage empty">Kein Bild</div>
				{/if}
				{#if admin}
					<label for="fshp-image" data-help="image" class="btn-primary btn-primary-circle icon-upload">Bild hochladen</label>
					<input id="fshp-image" data-help="image" type="file" accept="image/*" onchange={upload_image}>
				{/if}
				<p class="card-meta">Das Bild erscheint im Gruppenkatalog.</p>
			</section>
		</div>

		<Dialog id='members-dialog' title="Mitglieder verwalten"
		        actions={[{id: 'cancel', label: "Abbrechen"},
		                  {id: 'apply', label: "Fertig", symbol: 'check', shown: true, func: apply_members}]}>
			<div class="dlg-body dlg-narrow">
				<div class="field searchField">
					<span class="fa icon-magnifying-glass"></span>
					<input type="search" data-help="membersdialog" placeholder="Mitspieler suchen" bind:value={query}>
				</div>
				<ul class="memberList candidates" data-help="membersdialog">
					{#each candidates as userID (userID)}
						{@const isMember = pending.includes(userID)}
						<li class="memberRow">
							<span class="avatar">{initials(fellow_name(userID))}</span>
							<div class="memberName">
								<div>{fellow_name(userID)}</div>
								<div class="card-meta">{fellow_heroes(userID, fshp)}</div>
							</div>
							{#if userID === fshp.admin}
								<span class="tag accent">Admin</span>
							{:else if isMember}
								<button class="button-secondary" onclick={() => toggle_pending(userID)}>entfernen</button>
							{:else}
								<button class="button-secondary" onclick={() => toggle_pending(userID)}>hinzufügen</button>
							{/if}
						</li>
					{:else}
						<li class="card-meta">Kein Mitspieler gefunden.</li>
					{/each}
				</ul>
				<p class="card-meta">
					Hier stehen alle Mitspieler aus Deinen Gruppen.
					{#if fshp.invite}Neue Mitspieler können sich mit dem Einladungscode <b>{fshp.invite}</b> registrieren.{/if}
				</p>
			</div>
		</Dialog>
	{:else}
		<p class="card-meta">Bitte wähle zuerst in der Gruppenübersicht eine Gruppe aus.</p>
	{/if}
</article>


{#snippet memberRow(userID)}
	<li class="memberRow">
		<span class="avatar">{initials(fellow_name(userID))}</span>
		<div class="memberName">
			<div>{fellow_name(userID)}</div>
			<div class="card-meta">{fellow_heroes(userID, fshp)}</div>
		</div>
		{#if userID === fshp.admin}
			<span class="tag accent">Admin</span>
		{:else if admin}
			<button class="iconBtn fa icon-user-minus" title="aus Gruppe entfernen" onclick={() => remove_member(userID)}></button>
		{/if}
	</li>
{/snippet}


<!-------------------------------- STYLES -------------------------------------->

<style lang="sass">
	@use "../colors" as colors

	.titleRow
		display: flex
		align-items: center
		gap: 16px
		flex-wrap: wrap
		margin-bottom: 10px

		h1
			margin: 0
			font-size: 24px
			white-space: nowrap

	.nameField
		flex: 1
		max-width: 520px

		input
			font-size: 20px
			font-weight: bold

	.columns
		display: flex
		flex-wrap: wrap
		gap: 24px 36px
		align-items: flex-start

	.column
		display: flex
		flex-direction: column
		gap: 24px
		width: 460px
		max-width: 100%

	.imageCard
		width: 420px
		max-width: 100%

		label
			align-self: flex-start

		input[type=file]
			display: none

	.fshpImage
		width: 100%
		max-height: 400px
		object-fit: cover
		border-radius: 8px
		border: 1px solid colors.$grey-30

		&.empty
			display: grid
			place-items: center
			height: 260px
			background: colors.$grey-20
			color: colors.$grey-50

	.searchField
		position: relative

		.fa
			position: absolute
			left: 10px
			top: 9px
			font-size: 13px
			color: colors.$grey-50
			filter: none

		input
			padding-left: 32px

	.candidates
		max-height: 340px
		overflow-y: auto
		scrollbar-width: thin

		.button-secondary
			padding: 4px 12px
			font-size: 13px
</style>
